import { useEffect, useState } from 'react';
import { YardstikStatusesEnum } from '../../../__generated__/graphql';
import { getBackgroundCheckReportStatus } from './driver-certification.service';

const FETCH_REPORT_STATUS_SECONDS = 5; // Polling every 5 seconds
const CLEAR_INTERVAL_MINUTES = 20; // Clear interval after 20 minutes

function ReportStatusListener({ applicantId }: { applicantId: string }) {
  const [reportStatus, setReportStatus] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      if (!applicantId) return;

      getBackgroundCheckReportStatus({
        applicantId: applicantId || '',
      }).then(response => {
        setReportStatus(response?.status || '');
      });
    }, FETCH_REPORT_STATUS_SECONDS * 1000);

    const timeout = setTimeout(
      () => {
        clearInterval(interval);
      },
      CLEAR_INTERVAL_MINUTES * 60 * 1000,
    );

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [applicantId]);

  useEffect(() => {
    if (reportStatus && reportStatus !== YardstikStatusesEnum.Created) {
      window.location.href = '/status/sent';
    }
  }, [reportStatus]);

  return <div />;
}

export default ReportStatusListener;
